import Page from '../components/Page'
import Section from '../components/Section'
import Accordion from '../components/Accordion'
import PrimaryTitle from '../components/PrimaryTitle'
import LargeCard from '../components/LargeCard'
import paths from '../path'

const pageTitle = 'Virtuelle Realität für die Psychotherapie'

const hero = 'Durch neomento werden relevante Alltagssituationen jederzeit verfügbar und gut kontrollierbar.'

const specs = {
  title: 'neomento VR-Therapie in Zahlen:',
  sections: [
    {
      imgSrc: '/product/specs.svg',
      paragraphs: [
        'Weites Sichtfeld: FoV 110°',
        'Hohe Bildschärfe: 2880 x 1600 px',
        'Volle Bewegungsfreiheit: 6 DoF',
      ]
    },
    { imgSrc: '/product/eye.svg', paragraphs: ['Virtuelle Übungen: 20', 'Übungsoptionen: 66'] },
    { imgSrc: '/product/people.svg', paragraphs: ['Virtuelle Charaktere: 147', 'Interaktive Avatare: 38'] },
  ],
}

const current = 'Stand: 14.03.2022'

const treatment = {
  title: 'VR-Therapie muss man selbst erleben um ihre Möglichkeiten zu erkennen und den therapeutischen Wert zu erfassen.',
  description:
    '',
  cta: 'Vorführung buchen',
  ctaHref: paths.contact,
  imgSrc: '/vrBox.svg',
  imgAlt: 'vr',
}

export default function Product() {
  return (
    <Page title={pageTitle}>
      <Section>
        <div className='flex flex-col sm:flex-row space-x-0 sm:space-x-20'>
          <div className='flex-1'>
            <PrimaryTitle mainColor title={hero} />
          </div>
          <div className='flex-1'>
            <img className="w-full" src="/desktopScreen.png" alt="screen" />
          </div>
        </div>
      </Section>
      <Section>
        <Accordion type="scenarios" />
      </Section>
      <Section dark>
        <PrimaryTitle center title={specs.title}></PrimaryTitle>
        <p className='text-center text-xs'>{current}</p>
        <div className="flex flex-col lg:flex-row place-content-between space-x-0 lg:space-x-4 space-y-4 lg:space-y-0">
          {specs.sections.map((section, index) => (
            <div className="flex-1 px-8 lg:px-8 py-8 flex flex-col items-center" key={`section-${index}`}>
              <img className="pb-6 lg:pb-12" src={section.imgSrc} alt="" />
              {section.paragraphs.map((line, index) => (
                <p className='text-base' key={index}>{line}</p>
              ))}
            </div>
          ))}
        </div>
      </Section>
      <Section>
        <Accordion type="applications" />
      </Section>
      <Section>
        <LargeCard
          title={treatment.title}
          description={treatment.description}
          cta={treatment.cta}
          ctaHref={treatment.ctaHref}
          imgSrc={treatment.imgSrc}
          imgAlt={treatment.imgAlt}
        />
      </Section>
    </Page>
  )
}
